<div class="spinner-container">
  <div
    class="spinner"
    [style.color]="color"
    [style.width]="spinnerSize()"
    [style.height]="spinnerSize()"
  >
    <div
      [style.width]="size"
      [style.height]="size"
      [style.border-width]="thickness"
    ></div>
    <div
      [style.width]="size"
      [style.height]="size"
      [style.border-width]="thickness"
    ></div>
    <div
      [style.width]="size"
      [style.height]="size"
      [style.border-width]="thickness"
    ></div>
    <div
      [style.width]="size"
      [style.height]="size"
      [style.border-width]="thickness"
    ></div>
  </div>
  <div *ngIf="text" class="spinner-text" [style.color]="color">{{ text }}</div>
</div>
